// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2rXhN","content":"RecentSearches_content__2VFqq"};